import { Provider } from '@angular/core';
import { provideLandingRules } from './landing-rule';
import { ChinaBuyerBasketLandingRule } from './rules/china-buyer-basket.rule';
import { MobileBasketLandingRule } from './rules/mobile-basket.rule';
import { NoOrganizationsLandingRule } from './rules/no-organizations.rule';
import { OrderProBasketLandingRule } from './rules/order-pro-basket.rule';
import { SupplierDashboardLandingRule } from './rules/supplier-dashboard.rule';

/**
 * The User Journey. Rules are evaluated top-down and the first one returning a target wins.
 * A new rule or regional exception is a new `LandingRule` placed in this list;
 * the last rule is the fallback and always returns a target.
 */
export function provideUserJourney(): Provider {
  return provideLandingRules(
    NoOrganizationsLandingRule,
    MobileBasketLandingRule,
    SupplierDashboardLandingRule,
    ChinaBuyerBasketLandingRule,
    OrderProBasketLandingRule
  );
}
